/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendAdvancedProductDto } from '../../models/backend-advanced-product-dto';
import { BackendAdvancedProductRequestDto } from '../../models/backend-advanced-product-request-dto';

export interface SalesAdvancedProductsCreate$FormData$Params {
  body?: BackendAdvancedProductRequestDto;
}

export function salesAdvancedProductsCreate$FormData(
  http: HttpClient,
  rootUrl: string,
  params?: SalesAdvancedProductsCreate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendAdvancedProductDto>> {
  const rb = new RequestBuilder(rootUrl, salesAdvancedProductsCreate$FormData.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendAdvancedProductDto>;
    }),
  );
}

salesAdvancedProductsCreate$FormData.PATH = '/api/sales/advanced-products/';
